import { qq } from "bobjoll/ts/library/dom";

const getGTMPageData = function() {
  return {
    pageCode: document.body.classList.contains("error404")
      ? 404
      : document.body.classList.contains("error500")
      ? 500
      : 200,
    pageLang: LANGUAGE
  };
};

const getGTMUserData = function() {
  // const user = gr && gr.user ? gr.user : undefined;
  const data: GTMArguments = {
    userType: "anonymous",
    userAge: "nn",
    userLoginStatus: "not-logged",
    userFirstBuy: "nn"
  };
  // if (user) {
  //   let userFirstBuy =
  //     user.first_buy_fr &&
  //     user.first_buy_fr.source &&
  //     user.first_buy_fr.medium &&
  //     user.first_buy_fr.campaign;
  //   data.userType = user.user_type_fr || "nn";
  //   data.userAge = user.user_age || "nn";
  //   data.userLoginStatus = "logged";
  //   data.userFirstBuy =
  //     user && userFirstBuy
  //       ? `${user!.first_buy_fr!.source} / ${user!.first_buy_fr!.medium} / ${
  //           user!.first_buy_fr!.campaign
  //         }`
  //       : "nn";
  // }
  return data;
};

const getGTMCategoryData = function() {
  const checkStaticPageType: GTMPageTypeTesters = {
    home: {
      callbacks: [getGTMHomeData],
      selectors: [".home"]
    },
    category: {
      callbacks: [getGTMCategoriesData],
      selectors: [".category"]
    },
    post: {
      callbacks: [getGTMPostData],
      selectors: [".single-post"]
    },
    search: {
      callbacks: [getGTMSearchData],
      selectors: [".search"]
    }
  };
  let data = {
    catZone: "blog",
    catN1: "nn",
    catTag: "nn",
    catType: "nn"
  };
  let staticPageType = Object.keys(checkStaticPageType)
    .filter(key => {
      if (checkStaticPageType[key]) {
        return checkStaticPageType[key].selectors.filter(
          selector => qq(selector).length
        ).length;
      }
      return false;
    })
    .pop();
  if (staticPageType && checkStaticPageType[staticPageType]) {
    data = {
      ...data,
      ...checkStaticPageType[staticPageType].callbacks.reduce(
        (data, callback) => {
          data = {
            ...data,
            ...callback()
          };
          return data;
        },
        {}
      )
    };
  }
  return data;
};

const getGTMHomeData = function() {
  return {
    catZone: "blog",
    catN1: "nn",
    catTag: "nn",
    catType: "blog-home"
  };
};

const getGTMCategoriesData = function() {
  const category = document.body.dataset.cat;
  const categoryParent = document.body.dataset.catParent;

  return {
    catZone: "blog",
    catN1: categoryParent || category || "nn",
    catTag: categoryParent ? category : "nn",
    catType: "blog-list"
  };
};

const getGTMPostData = function() {
  const category = document.body.dataset.cat;
  const categoryParent = document.body.dataset.catParent;

  return {
    catZone: "blog",
    catN1: categoryParent || category || "nn",
    catTag: categoryParent ? category || "nn" : "nn",
    catType: "blog-item"
  };
};

const getGTMSearchData = function() {
  return {
    catZone: "blog",
    catN1: "nn",
    catTag: "nn",
    catType: "blog-search",
    searchResultNumber: document.body.dataset.searchTotal || "nn",
    searchQuery: document.body.dataset.searchQuery || "nn"
  };
};

const getOptimizeData = function() {
  if ("undefined" !== typeof google_tag_manager) {
    for (var gtm in google_tag_manager) {
      if (gtm.match(/^GTM/)) {
        if (google_tag_manager[gtm].experiment) {
          return {
            pageOptimizationContainer: gtm,
            pageOptimizationExperiment: google_tag_manager[
              gtm
            ].experiment.split("$")[0],
            pageOptimizationVersion:
              "Variation: " + google_tag_manager[gtm].experiment.split("$")[1]
          };
        }
      }
    }
  }
  return {
    pageOptimizationVersion: "nn"
  };
};

export const gtm = function(options?: GTMArguments) {
  let data = {
    event: "gtm.datalayer",
    ...options,
    // col.page
    ...getGTMPageData(),
    // col.user
    ...getGTMUserData(),
    // Optimize
    ...getOptimizeData(),
    // Cat
    ...getGTMCategoryData()
  };

  dataLayer.push(data);
};

type GTMProjectTypes = "static";
type GTMMethodType = () => { [name: string]: any };

interface GTMArguments {
  [name: string]: string;
}

interface GTMPageTypeTesters {
  [name: string]: {
    callbacks: GTMMethodType[];
    selectors: string[];
  };
}
